import React from 'react';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';

// ! below code is festive modal code, we can use it later
// import { useNavigate } from 'react-router-dom';

function CommonUnlockModal({ classname, handleCloseUnlockModal, signInHandle }) {

// ! below code is festive modal code, we can use it later
    // const navigate = useNavigate();

    return (
        <>
            <div className={`${classname}`}>
                <div className='bs-banner-form__media-wrap'>
                    <CloudinaryAdvancedImage imagePublicId='login-img' className='bs-banner-form__image' type="section-image-landscape" />
                    <div className='bs-banner-form__logo'>
                    </div>
                </div>

                {/* //! below code is festive modal code, we can use it later */}
                {/* <div className='bs-banner-form__cont-wrap'>
                    <div className="bs-success-msg bs-success-msg--typ-2">
                        <div className='bs-success-msg__info-wrap'>
                            <h4 className='bs-success-msg__title'>Festive Savings Are Here!</h4>
                            <h4 className='bs-success-msg__title'>Get</h4>  
                            <h4 className='bs-success-msg__title-2'>10% Off</h4>  
                            <p className='bs-success-msg__desc'>on all bedding products-</p>
                            <p className='bs-success-msg__desc'>because rest is a ritual too</p>
                            <h6 className='bs-success-msg__sub-title-2'>Valid till Diwali!</h6>
                        </div>
                        <div className='bs-success-msg__action-wrap'>
                            <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-success-msg__primary-cta' onClick={()=>{navigate('/shop')}}>Shop Now</button>
                        </div>
                    </div>
                </div> */}

                <div className='bs-banner-form__cont-wrap'>
                    <div className="bs-success-msg bs-success-msg--typ-2">
                        <div className='bs-success-msg__info-wrap'>
                            <h4 className='bs-success-msg__title'>Step Into the World of SANSAAR</h4>
                            <h6 className='bs-success-msg__sub-title'>Thoughtfully made. Mindfully curated</h6>
                            <p className='bs-success-msg__desc'>Be the first to discover our new collections, stories of craft, and the journey toward conscious living.</p>
                        </div>
                        <div className='bs-success-msg__action-wrap'>
                            <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-success-msg__primary-cta' onClick={signInHandle}>Sign up</button>
                            <div className='mod-text-btn'>
                                <p className='mod-text-btn__text'>already a user? <button className='bs-btn bs-btn__btn-link mod-text-btn__link' onClick={signInHandle}>login now</button></p>
                            </div>
                            <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-btn__btn-solid--inverse-border bs-success-msg__secondary-cta' onClick={() => handleCloseUnlockModal()}>continue as a guest</button>
                        </div>
                    </div>
                </div>


            </div>
        </>
    )
}

export default CommonUnlockModal